import { Controller } from "@hotwired/stimulus"

const SWIPE_THRESHOLD = 60
const ACTION_WIDTH = 72

export default class extends Controller {
  static targets = ["content"]
  static values = { url: String }

  connect() {
    this._startX = 0
    this._currentX = 0
    this._swiping = false
    this._open = false

    this._onTouchStart = (e) => this._touchStart(e)
    this._onTouchMove = (e) => this._touchMove(e)
    this._onTouchEnd = () => this._touchEnd()

    this.contentTarget.addEventListener("touchstart", this._onTouchStart, { passive: true })
    this.contentTarget.addEventListener("touchmove", this._onTouchMove, { passive: false })
    this.contentTarget.addEventListener("touchend", this._onTouchEnd)
  }

  disconnect() {
    this.contentTarget.removeEventListener("touchstart", this._onTouchStart)
    this.contentTarget.removeEventListener("touchmove", this._onTouchMove)
    this.contentTarget.removeEventListener("touchend", this._onTouchEnd)
    this._cleanupModal()
  }

  _touchStart(e) {
    this._startX = e.touches[0].clientX
    this._startY = e.touches[0].clientY
    this._swiping = false
    this._directionLocked = false
    this.contentTarget.style.transition = "none"
  }

  _touchMove(e) {
    const dx = e.touches[0].clientX - this._startX
    const dy = e.touches[0].clientY - this._startY

    // Lock direction on first significant move
    if (!this._directionLocked && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
      this._directionLocked = true
      this._isHorizontal = Math.abs(dx) > Math.abs(dy)
    }

    // If vertical scroll, don't interfere
    if (!this._isHorizontal) return

    e.preventDefault()
    this._swiping = true

    // Calculate offset based on current state
    const base = this._open ? -ACTION_WIDTH : 0
    let offset = base + dx

    // Clamp: don't swipe right past origin, don't swipe left past action width
    offset = Math.min(0, Math.max(-ACTION_WIDTH - 20, offset))

    this._currentX = offset
    this.contentTarget.style.transform = `translateX(${offset}px)`
  }

  _touchEnd() {
    if (!this._swiping) return

    this.contentTarget.style.transition = "transform 0.2s ease-out"

    if (this._open) {
      if (this._currentX > -SWIPE_THRESHOLD) {
        this._close()
      } else {
        this._snapOpen()
      }
    } else {
      if (this._currentX < -SWIPE_THRESHOLD) {
        this._snapOpen()
      } else {
        this._close()
      }
    }
  }

  _snapOpen() {
    this._open = true
    this.contentTarget.style.transform = `translateX(-${ACTION_WIDTH}px)`
  }

  _close() {
    this._open = false
    this.contentTarget.style.transform = "translateX(0)"
  }

  confirmDelete() {
    const modalEl = document.getElementById('modal_delete_conversation')
    if (!modalEl) return

    const confirmBtn = modalEl.querySelector('#confirm-delete-conversation')

    // Store reference so we can clean up
    this._onConfirm = () => {
      $(modalEl).modal('hide')
      this._performDelete()
    }
    this._onHidden = () => {
      this._close()
      this._cleanupModal()
    }

    confirmBtn.addEventListener('click', this._onConfirm)
    $(modalEl).on('hidden.bs.modal', this._onHidden)
    $(modalEl).modal('show')
  }

  _cleanupModal() {
    const modalEl = document.getElementById('modal_delete_conversation')
    if (!modalEl) return
    const confirmBtn = modalEl.querySelector('#confirm-delete-conversation')
    if (this._onConfirm) confirmBtn.removeEventListener('click', this._onConfirm)
    if (this._onHidden) $(modalEl).off('hidden.bs.modal', this._onHidden)
    this._onConfirm = null
    this._onHidden = null
  }

  _performDelete() {
    if (!this.urlValue) return

    const wrapper = this.element
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    // Animate out
    wrapper.style.transition = "opacity 0.2s ease-out, max-height 0.3s ease-out"
    wrapper.style.opacity = "0"
    wrapper.style.maxHeight = wrapper.offsetHeight + "px"

    setTimeout(() => {
      wrapper.style.maxHeight = "0"
      wrapper.style.overflow = "hidden"
    }, 50)

    fetch(this.urlValue, {
      method: "DELETE",
      headers: { "X-CSRF-Token": csrfToken, "Accept": "application/json" }
    }).then(response => {
      if (response.ok) {
        setTimeout(() => wrapper.remove(), 350)
      }
    }).catch(() => {
      wrapper.style.opacity = "1"
      wrapper.style.maxHeight = ""
      wrapper.style.overflow = ""
      this._close()
    })
  }
}
